import { styled } from '@mui/material/styles';
import MuiPhoneNumber from 'react-phone-input-2';
import Modal from '@ui/Modal';
import IconButton from '@mui/material/IconButton';
import Typography from '@components/Typography';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from "@components/Button";

import { FontFamilyNames } from 'app/types/fonts';

import { COLORS } from '@utils/colors';


export const StyledModal = styled(Modal)(({ theme }) => ({
  '.MuiPaper-root': {
    width: '100%',
    maxWidth: '670px',
    maxHeight: '572px',
    borderRadius: 20,
  },

  [theme.breakpoints.down('sm')]: {
    borderRadius: 0,

    '.MuiPaper-root': {
      maxWidth: 'unset',
      margin: 0,
      borderRadius: 0,
      height: '100vh',
      maxHeight: '100%',
    },
  },
}));

export const StyledForm = styled('form')(() => ({
  maxWidth: 334,
  width: '100%',
  margin: '0px auto',

  '> div': { // wrapper
    position: 'relative',
  }
}));


export const StyledDialogContent = styled(Box)(({ theme }) => ({
  padding: '55px 0 53px 0',
  borderRadius: 20,
  minHeight: 500,
  display: 'grid',
  griTemplateRows: '1fr',

  [theme.breakpoints.down('sm')]: {
    padding: '127px 60px 0 60px',
  },
}));

export const StyledModalTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontSize: 40,
  lineHeight: 'normal',
  marginBottom: 19,

  [theme.breakpoints.down('sm')]: {
    fontSize: 30,
  },
}));

export const FieldWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',

  '> .MuiTypography-body1': {
    position: 'absolute',
    top: 'calc(100% - 23px)'
  },

  [theme.breakpoints.down('sm')]: {
    width: '100%'
  }
}))

export const StyledTextField = styled(TextField)(({ theme }) => ({
  width: '100%',
  maxHeight: 35,
  marginBottom: 25,

  '& .MuiOutlinedInput-root': {
    borderBottom: `1px solid ${COLORS.darkBlue}`,
    borderRadius: 0,
  },
  '& .MuiInputBase-input': {
    color: COLORS.darkBlue,
    fontSize: 16,
    padding: '0px 0px 14px 0',
    letterSpacing: '-0.02em',
  },

  '& ::placeholder': {
    color: COLORS.darkBlue,
    opacity: 0.5,
  },
  'input:-webkit-autofill': {
    boxShadow: '0 0 0 1000px white inset !important',
  },

  [theme.breakpoints.down('sm')]: {
    marginBottom: 30,
    maxHeight: 31,
    width: '100%',

    '& .MuiOutlinedInput-root': {
      width: '100%',
    },

    '& .MuiInputBase-input': {
      fontSize: '14px',
      textAlign: 'left',
      paddingLeft: 0,
    },
  },
}));

export const StyledTextArea = styled('textarea')(({ theme }) => ({
  fontFamily: FontFamilyNames.PlainLight,
  fontSize: 16,
  padding: '12px 15px 108px 15px',
  width: '100%',
  maxHeight: 140,
  borderRadius: 14,
  color: COLORS.darkBlue,
  // opacity: 0.5,
  border: `1px solid ${COLORS.darkBlue}`,

  '::-webkit-scrollbar': {
    display: 'none'
  },

  '-ms-overflow-style': 'none',
  'scrollbar-width': 'none',

  '&::placeholder': {
    opacity: 0.5,
    color: COLORS.darkBlue,
  },

  [theme.breakpoints.down('sm')]: {
    paddingBottom: 176,
    width: '100%',
    minHeight: 207,
  },
}));

export const StyledSubmitButton = styled(Button)(({ theme }) => ({
  marginTop: 12,
  minHeight: 48,
  width: 158,
  fontSize: '24px',
  padding: '4px 30px',
  fontFamily: FontFamilyNames.MoretRegular,

  [theme.breakpoints.down('sm')]: {
    width: '100%',
    maxWidth: 'unset',
    marginTop: 14,
    padding: '9px 45px',
    height: 36,
    fontSize: 20,
  },
}));

export const StyledLeftLogo = styled('img')(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  left: 0,

  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

export const StyledRightLogo = styled('img')(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  right: 0,

  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

export const StyledIconButton = styled(IconButton)(() => ({
  position: 'absolute',
  zIndex: 999,
  right: 41,
  top: 41,
  color: COLORS.darkBlue,

  svg: {
    width: 18,
    height: 18,
  },
}));

export const StyledPhoneNumber = styled(MuiPhoneNumber)(({ theme }) => ({
  width: '100%',
  borderRadius: 0,
  borderBottom: `1px solid ${COLORS.darkBlue}`,
  marginBottom: 21,
  input: {
    width: '100%',
    border: 'none',
    background: 'transparent',
    padding: '0 0 14px 0',
    fontSize: '16px',
    color: COLORS.darkBlue,
  },
  '.form-control::placeholder': {
    color: COLORS.darkBlue,
    opacity: 0.5,
  },
  '.form-control:focus-visible': {
    outlineWidth: 0,
  },
  '& .special-label': {
    display: 'none',
  },
  [theme.breakpoints.down('sm')]: {
    marginBottom: 30,
    width: '100%',
    input: {
      fontSize: '14px',
      textAlign: 'left',
      paddingLeft: 0,
    },
  },
}));

export const AreaWrapper = styled(Box)(() => ({
  marginBottom: 19
}))

export const StyledSuccessMessage = styled(Typography)(() => ({
  color: COLORS.orange,
  position: 'absolute',
  top: '100%',
  fontFamily: FontFamilyNames.MoretRegular,
  fontSize: '24px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: 'normal',
}))

export const StyledLocalErrorMessage = styled(Typography)(() => ({
  color: COLORS.error.main,
  position: 'absolute',
  top: '100%',
}))


export const ThanksWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',

  p: {
    color: '#282750',
    textAlign: 'center',

    fontFamily: FontFamilyNames.PlainLight,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 300,
    lineHeight: '130%',
    letterSpacing: '-0.32px',
    marginTop: 31
  },
  button: {
    marginTop: 31
  },

  [theme.breakpoints.down('sm')]: {
    p: {
      fontSize: '14px',
    },
    button: {
      fontSize: '24px',
    },
  },
}))
